import React from 'react'
import { MarkerSvgProps } from './MarkerSvgProps'

export const NotContractedSvg = ({ style }: MarkerSvgProps) => {
  return (
    <svg
      width="32"
      height="40"
      viewBox="0 0 32 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <g opacity="0.35" filter="url(#filter0_f_8284_162510)">
        <path
          d="M24 34.5C24 35.8807 20.4183 37 16 37C11.5817 37 8 35.8807 8 34.5C8 33.1193 11.5817 32 16 32C20.4183 32 24 33.1193 24 34.5Z"
          fill="black"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.599609 5.0001C0.599609 2.57005 2.56956 0.600098 4.99961 0.600098H26.9996C29.4297 0.600098 31.3996 2.57004 31.3996 5.0001V25.0001C31.3996 27.4301 29.4297 29.4001 26.9996 29.4001H21.0058L17.9526 33.6746C16.9954 35.0146 15.0038 35.0146 14.0466 33.6746L10.9934 29.4001H4.99961C2.56956 29.4001 0.599609 27.4302 0.599609 25.0001V5.0001ZM1.99961 5.0001C1.99961 3.34324 3.34276 2.0001 4.99961 2.0001H26.9996C28.6565 2.0001 29.9996 3.34324 29.9996 5.0001V25.0001C29.9996 26.6569 28.6565 28.0001 26.9996 28.0001H20.7999C20.477 28.0001 20.1739 28.1561 19.9862 28.4189L16.8133 32.8609C16.4145 33.4192 15.5847 33.4192 15.1859 32.8609L12.013 28.4189C11.8253 28.1561 11.5222 28.0001 11.1993 28.0001H4.99961C3.34276 28.0001 1.99961 26.657 1.99961 25.0001V5.0001Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 2C3.34315 2 2 3.34315 2 5V25C2 26.6569 3.34315 28 5 28H11.1997C11.5226 28 11.8257 28.156 12.0134 28.4188L15.1863 32.8608C15.5851 33.4191 16.4149 33.4191 16.8137 32.8608L19.9866 28.4188C20.1743 28.156 20.4774 28 20.8003 28H27C28.6569 28 30 26.6569 30 25V5C30 3.34315 28.6569 2 27 2H5Z"
        fill="#7F7D76"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 3C3.89543 3 3 3.89543 3 5V25C3 26.1046 3.89543 27 5 27H11.1997C11.8456 27 12.4517 27.3119 12.8271 27.8375L16 32.2795L19.1729 27.8375C19.5483 27.3119 20.1544 27 20.8003 27H27C28.1046 27 29 26.1046 29 25V5C29 3.89543 28.1046 3 27 3H5ZM2 5C2 3.34315 3.34315 2 5 2H27C28.6569 2 30 3.34315 30 5V25C30 26.6569 28.6569 28 27 28H20.8003C20.4774 28 20.1743 28.156 19.9866 28.4188L16.8137 32.8608C16.4149 33.4191 15.5851 33.4191 15.1863 32.8608L12.0134 28.4188C11.8257 28.156 11.5226 28 11.1997 28H5C3.34315 28 2 26.6569 2 25V5Z"
        fill="#7F7D76"
      />
      <path
        d="M11.5167 13.9917C12.7167 16.35 14.65 18.275 17.0083 19.4833L18.8417 17.65C19.0667 17.425 19.4 17.35 19.6917 17.45C20.625 17.7583 21.6333 17.925 22.6667 17.925C23.125 17.925 23.5 18.3 23.5 18.7583V21.6667C23.5 22.125 23.125 22.5 22.6667 22.5C14.8417 22.5 8.5 16.1583 8.5 8.33333C8.5 7.875 8.875 7.5 9.33333 7.5H12.25C12.7083 7.5 13.0833 7.875 13.0833 8.33333C13.0833 9.375 13.25 10.375 13.5583 11.3083C13.65 11.6 13.5833 11.925 13.35 12.1583L11.5167 13.9917Z"
        fill="white"
      />
      <defs>
        <filter
          id="filter0_f_8284_162510"
          x="5"
          y="29"
          width="22"
          height="11"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="1.5"
            result="effect1_foregroundBlur_8284_162510"
          />
        </filter>
      </defs>
    </svg>
  )
}
